export const environment = {
  environment: 'dev02',
  production: false,
  baseUrl: 'https://api-services.dev02.1placedessaisons.com/dev02',
  paymentPortalApiUrl: 'payment-portal/v1/payments',
};
